/**
 * wql
 * @description 路径路径管理
 * @Date  2020/8/13
 */
 import React from "react";
 import { connect } from "dva";
 import { templateConfig, reduxTemplateCofig } from "./config";
 import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';
 
 import { component_tool, framework_tool } from '../../../../tool';
 let { WizContainer, WizReduxTemplate } = framework_tool;
 let { WizBrowserExport } = component_tool;
 
 
 class TrainPathStageScoreRule extends WizContainer {
   componentName = 'trainPathStageScoreRule';
   constructor(props) {
     super(props);
     this.state = {
     }
   }
 
   _handleCMD(nextProps, nextState, key) {
     let o = nextProps[key]
     if (o['success']) {
       wizNotice.success(o['msg'])
       return true;
     } else {
       wizNotice.error(o['msg'])
       return false;
     }
   }
 

   _render() {
     let _reduxTemplateCofig = reduxTemplateCofig({
       templateConfig,
       apiDataFormat: {
         enable: this._handleCMD,
         del: this._handleCMD
       },
     })
     return <WizReduxTemplate {..._reduxTemplateCofig} />
   }
 }
 
 const mapStateToProps = (state, ownProps) => {
   return {}
 };
 
 export default connect(mapStateToProps)(TrainPathStageScoreRule);
 